var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5197 3.978L30.209 15.4368H41.6587L45.6879 9.2384C47.1698 6.95874 46.4922 3.90672 44.1848 2.46839C41.9249 1.05966 38.9521 1.73299 37.5197 3.978ZM3.96503 32.8619L2.88702 23.2809C2.63927 21.079 4.3622 19.1513 6.57802 19.1513H45.425C47.6408 19.1513 49.3637 21.079 49.116 23.2809L48.038 32.8619C47.4801 37.8203 44.5235 41.9801 40.4042 44.2367C40.9857 45.3767 41.3942 46.6254 41.5927 47.951C41.8672 49.784 40.4475 51.4321 38.5942 51.4321H13.4084C11.555 51.4321 10.1354 49.784 10.4099 47.951C10.6084 46.6253 11.0169 45.3766 11.5985 44.2365C7.47937 41.9799 4.52291 37.8201 3.96503 32.8619ZM28.3249 28.125C28.3249 26.8429 27.2856 25.8036 26.0035 25.8036C24.7214 25.8036 23.682 26.8429 23.682 28.125V32.9671H18.8365C17.5544 32.9671 16.5151 34.0065 16.5151 35.2886C16.5151 36.5707 17.5544 37.61 18.8365 37.61H23.682V42.4552C23.682 43.7373 24.7214 44.7767 26.0035 44.7767C27.2856 44.7767 28.3249 43.7373 28.3249 42.4552V37.61H33.1667C34.4488 37.61 35.4882 36.5707 35.4882 35.2886C35.4882 34.0065 34.4488 32.9671 33.1667 32.9671H28.3249V28.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharma);
export default __webpack_public_path__ + "static/media/Pharma.2806f6abdc848555a4cb796a6f7094ff.svg";
export { ForwardRef as ReactComponent };